import { useNavigate } from '@tanstack/react-router';

import { Button } from '../cdl/Button/Button';
import { Text } from '../cdl/Text/Text';
import { ButtonGroup } from '../common/buttons/ButtonGroup';
import { translate } from '../common/helpers/translate.helper';
import { Box } from '../common/ui/Box';
import { theme } from '../common/ui/theme';

export const AuthError = () => {
    const navigate = useNavigate();

    const handleRetryLogin = () => {
        // Navigate to logout first to clear any corrupted auth state and start fresh
        navigate({ to: '/logout' });
    };

    return (
        <Box display="flex" justifyContent="center" paddingTop="256px">
            <Box display="grid" gap={theme.space[32]} width="560px">
                <Box display="grid" gap={theme.space[16]}>
                    <Text variant="display">{translate('authentication.error.headline')}</Text>
                    <Text variant="body" color={theme.colors.foreground.muted}>
                        {translate('authentication.error.message')}
                    </Text>
                </Box>

                <ButtonGroup>
                    <Button emphasis="high" onClick={handleRetryLogin}>
                        {translate('authentication.error.button')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Box>
    );
};
